import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { PluginGooglemapService } from './udo-plugin.service';
import { CommonModule } from '@angular/common';
import { PluginGooglemapComponent } from './components/googlemap.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    PluginGooglemapComponent
  ],
  exports: [
    PluginGooglemapComponent
  ],
  providers: [
    PluginGooglemapService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class PluginGooglemapModule { }
